import {
  Children,
  cloneElement,
  MouseEvent as ReactMouseEvent,
  MouseEventHandler,
  ReactElement,
  ReactNode,
} from 'react';

import useDialogHandler from '../../../hooks/useDialogHandler';
import { isFunction } from '../../../utils/is';

type Props<Element extends HTMLElement> = {
  renderDialog: ({ isOpen, closeDialog }: { isOpen: boolean; closeDialog: () => void }) => React.ReactNode;
  onClick?: (e: ReactMouseEvent<Element, MouseEvent>) => void;
  /** 링크로 진입했을 때처럼 처음부터 열린 채로 두고 싶을 때 */
  defaultOpen?: boolean;
  children: ReactNode | (({ openDialog }: { openDialog: () => void }) => ReactNode);
};

const DialogHandler = <Element extends HTMLElement>({
  renderDialog,
  onClick,
  defaultOpen,
  children: propChildren,
}: Props<Element>) => {
  const { isOpen, openDialog, closeDialog } = useDialogHandler(defaultOpen);

  const handleClick: MouseEventHandler<Element> = (e) => {
    onClick?.(e);
    openDialog();
  };

  const children = isFunction(propChildren)
    ? (propChildren({ openDialog }) as JSX.Element)
    : Children.map(propChildren, (child) =>
        cloneElement(child as ReactElement<{ onClick: MouseEventHandler<Element> }>, {
          onClick: handleClick,
        }),
      );

  return (
    <>
      {children}
      {renderDialog({ isOpen, closeDialog })}
    </>
  );
};

export default DialogHandler;
